import { STORAGE_KEYS } from '~constants'

const removeOAuth2Params = () => {
  localStorage.removeItem(STORAGE_KEYS.OAUTH2_PARAMS)
}

export default removeOAuth2Params
